import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/zkbio-settings', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/zkbio-settings', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDevices = (Options = {}) => {
  return httpClient
    .get('/api/zkbio-device-maps/devices', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, getDevices }
